/**
 * @typedef {'stripe_payment'|'stripe_refund'|'email'|'calendar'|'backup'|'general'} ErrorType
 * @typedef {{ booking_id?: string, client_email?: string, [key: string]: unknown }} ErrorContext
 */

/**
 * Supabase error_logs 테이블에 오류 기록
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 * @param {ErrorType} type
 * @param {string} message
 * @param {ErrorContext} context
 */
export async function logError(supabase, type, message, context = {}) {
  try {
    await supabase.from('error_logs').insert([{
      error_type: type,
      error_message: message,
      context,
    }]);
  } catch (_) {
    console.warn('Error log failed:', type, message);
  }
}
